import React, { useEffect } from 'react';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { Title1 } from '../../../../components/Typography';
import OrderFutureSchedule from '../../OrderSettingModal/components/OrderFutureSchedule';
import appConfig from '../../../../../app-config';
import SkeletonLoading from '../../OrderSettingModal/components/SkeletonLoading';
import { isConfirmButtonDisabled } from '../../OrderSettingModal/utils/helper';
import ConfirmButton from '../../OrderSettingModal/components/ConfirmButton';
import { isScheduleRadioDisabledCalculated } from '../../OrderSettingModal/utils/helper';
import UnavailableProducts from '../../OrderSettingModal/components/UnavailableProducts';
import { PICKUP, DROPOFF } from '../../orderSettingTypes';

const Wrapper = styled.div`
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  padding: 32px;
  max-width: 500px;
  @media (min-width: 786px) {
    width: 500px;
  }
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`;

const CloseButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  background-color: ${(props) => props.theme.darkGray};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const styles = (theme) => ({
  input: {
    fontFamily: theme.typography.fontFamily.main,
  },
});

const PickUpTimeForm = ({
  setPickUpTimeFormIsVisible,
  location,
  interOrderType,
  interSelectedDateTime,
  updateInterSelectedDateTime,
  confirmDeliveryDetails,
  availableTimes,
  selectedDateTime,
  isTimeNoLongerValid,
  resetIsTimeNoLongerValid,
  getTimeIntervalsDate,
  specialHours,
  orderPacingData,
  isOnline,
  emptySearchBox,
  deepLinkParameters,
  isConfirmMarketPlaceDeliveryDetailsRequest,
  unavailableProducts,
  cartErrorMessage,
  checkUnavailableProductForMarketplace,
  resetUnavailableProducts,
  confirmPickUpDetails,
  updateSelectedLocation,
  cartReducer,
  resetCartErrorMessages,
  confirmDropOffDetails,
  onSeeMenu,
  selectMarketplacePickUpLocation,
  updateCartWithUnavailbleProducts,
  isAuthenticated,
  emptyCart,
  updateUnavailableProducts,
  showConfirmButton,
  setShowConfirmButton,
}) => {
  const maxFutureOrderDate =
    location && location.settings && location.settings.max_future_order_date;

  const orderEndTime =
    location &&
    location.availableTimes &&
    location.availableTimes.length &&
    (location.availableTimes.length > 1
      ? location.availableTimes[1].order_end_time
      : location.availableTimes[0].order_end_time);

  const isAsapRadioDisabled =
    !(location && location?.accepting_orders) ||
    !isOnline ||
    (location.orderPacingData &&
      !location.orderPacingData.is_asap_slot_available);

  let isScheduleRadioDisabled = true;

  if (location) {
    isScheduleRadioDisabled = isScheduleRadioDisabledCalculated(
      location.availableTimes,
      maxFutureOrderDate,
      orderEndTime,
      location.specialHours,
      isOnline
    );
  }

  useEffect(() => {
    if (
      (interSelectedDateTime.radioValue.value === 'asap' ||
        interSelectedDateTime.dateTime.time.value.length) &&
      interOrderType === 'pickup'
    ) {
      checkUnavailableProductForMarketplace(location);
    }
  }, [interSelectedDateTime.radioValue.value]);

  return (
    <Wrapper>
      <TitleWrapper>
        <Title1 style={{ fontWeight: '600', marginBottom: '20px' }}>
          {interOrderType
            ? interOrderType.charAt(0).toUpperCase() +
              interOrderType.slice(1).replace('_', '-')
            : 'Order'}{' '}
          Time
        </Title1>

        <CloseButton
          onClick={() => {
            //resetUnavailableProducts();
            setPickUpTimeFormIsVisible(false);
            resetCartErrorMessages();
            updateUnavailableProducts(null);
          }}
        >
          <i
            className='fas fa-times'
            style={{ fontSize: '24px', cursor: 'pointer' }}
          ></i>
        </CloseButton>
      </TitleWrapper>
      <div style={{ marginBottom: '32px' }}>
        {isConfirmMarketPlaceDeliveryDetailsRequest ? (
          <SkeletonLoading />
        ) : (
          <OrderFutureSchedule
            selectedLocation={location}
            interOrderType={interOrderType}
            interSelectedDateTime={interSelectedDateTime}
            updateInterSelectedDateTime={updateInterSelectedDateTime}
            confirmDeliveryDetails={confirmDeliveryDetails}
            confirmDropOffDetails={confirmDropOffDetails}
            confirmPickUpDetails={confirmPickUpDetails}
            availableTimes={availableTimes}
            selectedDateTime={selectedDateTime}
            maxFutureOrderDate={
              location && location.settings.max_future_order_date
            }
            isTimeNoLongerValid={isTimeNoLongerValid}
            resetIsTimeNoLongerValid={resetIsTimeNoLongerValid}
            isLocationOrDelivBusinesssAcceptingOrders={
              location && location.accepting_orders
            }
            getTimeIntervalsDate={getTimeIntervalsDate}
            specialHours={specialHours}
            orderPacingData={orderPacingData}
            orderMessage={appConfig.orderMessageDelivery}
            isOnline={location && location.settings.online}
            onSeeMenu={onSeeMenu}
            emptySearchBox={() => emptySearchBox()}
            deepLinkParameters={deepLinkParameters}
            isMarketplaceDelivery={true}
            setPickUpTimeFormIsVisible={setPickUpTimeFormIsVisible}
            is_asap_order_enabled={
              location ? location.settings.is_asap_order_enabled : false
            }
            is_future_order_enabled={
              location ? location.settings.is_future_order_enabled : false
            }
            cartReducer={cartReducer}
            selectMarketplacePickUpLocation={selectMarketplacePickUpLocation}
            emptyCart={emptyCart}
            updateSelectedLocation={updateSelectedLocation}
            setShowConfirmButton={setShowConfirmButton}
            showConfirmButton={showConfirmButton}
          />
        )}
        {unavailableProducts && unavailableProducts.length ? (
          <UnavailableProducts
            cartErrorMessage={cartErrorMessage}
            marginBottom='25px'
          />
        ) : null}
      </div>

      {!isConfirmMarketPlaceDeliveryDetailsRequest && showConfirmButton && (
        <ConfirmButton
          text={
            location &&
            isAsapRadioDisabled &&
            isScheduleRadioDisabled &&
            !location.accepting_orders &&
            !(location.settings && location.settings.is_future_order_enabled)
              ? 'See Menu'
              : 'Confirm'
          }
          onClick={() => {
            if (location) {
              selectMarketplacePickUpLocation();
              if (!isAuthenticated) {
              } else if (
                unavailableProducts &&
                unavailableProducts.length > 0
              ) {
                updateCartWithUnavailbleProducts(unavailableProducts);
              }

              if (interOrderType === PICKUP) {
                confirmPickUpDetails(true);
              } else if (interOrderType === DROPOFF) {
                confirmDropOffDetails(true);
              }
              resetCartErrorMessages();
            }
            resetUnavailableProducts();
            setPickUpTimeFormIsVisible(false);
            updateSelectedLocation(null);
          }}
          disabled={
            !location ||
            isConfirmButtonDisabled(
              interSelectedDateTime,
              appConfig.isFutureOrderPickup,
              location
            ) ||
            (!location?.settings?.is_asap_order_enabled &&
              !location?.settings?.is_future_order_enabled)
          }
        />
      )}
    </Wrapper>
  );
};

export default withStyles(styles)(PickUpTimeForm);
